/// <amd-module name="Agile/Common/Utils/BacklogMembershipEvaluator" />
import { IBacklogLevelConfiguration } from "Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationContracts";
import { IIterationData, ITeamFieldData } from "Agile/Contracts/Common";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";

export interface IWorkItemDetails {
    workItemType: string;
    teamFieldValue: string;
    iterationPath: string;
}

/**
 * Checks if the given workitem details match criteria for a backlogLevel(s) and team
 */
export function isMemberOfBacklog(
    workItemDetails: IWorkItemDetails,
    allowedBacklogLevels: IBacklogLevelConfiguration[],
    allowedTeamFieldValues: ITeamFieldData[],
    allowedTeamIterations: IIterationData[]
) {
    const { workItemType, teamFieldValue, iterationPath } = workItemDetails;
    const allWorkItemTypes: string[] = [];

    allowedBacklogLevels.forEach(bl => allWorkItemTypes.push(...bl.workItemTypes));

    return (
        isValidWorkItemType(workItemType, allWorkItemTypes) &&
        !!getMatchingIteration(iterationPath, allowedTeamIterations) &&
        isValidTeamField(teamFieldValue, allowedTeamFieldValues)
    );
}
export function getMatchingIteration(iterationPath: string, allowedIterations: IIterationData[]) {
    iterationPath = iterationPath.toLocaleLowerCase();
    // We always allow children of team iterations to be included in the backlog
    return allowedIterations.find(itr => iterationPath.indexOf(itr.friendlyPath.toLocaleLowerCase()) === 0);
}

function isValidWorkItemType(workItemType: string, allowedWorkItemTypes: string[]) {
    return allowedWorkItemTypes.some(wit => localeIgnoreCaseComparer(wit, workItemType) === 0);
}

function isValidTeamField(teamFieldValue: string, allowedTeamFieldValues: ITeamFieldData[]) {
    teamFieldValue = teamFieldValue.toLocaleLowerCase();
    return allowedTeamFieldValues.some(tfv => {
        const tfvValue = tfv.value.toLocaleLowerCase();
        return tfvValue === teamFieldValue || (!!tfv.includeChildren && teamFieldValue.indexOf(tfvValue + "\\") === 0);
    });
}
